import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getActivityList, getActivityDetail, createActivity, updateActivity, deleteActivity, auditActivity, updateActivityStatus } from '@/api/bairun/oilActivity'; //  此处请自行替换地址

import { getTicketRuleDetail } from '@/api/bairun/ticket'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';
import vueQr from 'vue-qr';

var _this;

export default {
  name: 'OilScanActivity',
  components: {
    vueQr: vueQr
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getActivityList,
      type: '',
      path: process.env.VUE_APP_BASE_API,
      discountLevel: 1,
      activityType: 100005,
      fullscreenLoading: false,
      multipleSelection: [],
      addDialogVisible: false,
      stepActive: 1,
      viewDialogVisible: false,
      auditDialogVisible: false,
      qrcodeDialogVisible: false,
      bairunLogo: '',
      qrcodeText: '',
      dialogTitle: '',
      dateRangeValueArr: [],
      formData: {}
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var logoRes;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('scanActivity init');
                _this3.formData = _this3.initData();
                _this3.searchInfo.discountLevel = _this3.discountLevel;
                _this3.searchInfo.activityType = _this3.activityType;

                _this3.getTableData();

                _context3.next = 7;
                return _this3.filterDictItem(0, 'logo');

              case 7:
                logoRes = _context3.sent;
                _this3.bairunLogo = logoRes.label;

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        activityNo: '',
        activityScancodeNo: '',
        activityName: '',
        activityStatus: 2,
        dateStart: '',
        isShowDialog: 2,
        dateEnd: '',
        scancodeTicketList: [this.initTicketSingle()],
        shareTitle: '',
        shareAppLogo: '',
        shareTimeLineLogo: '',
        auditStatus: 2,
        auditRemark: '',
        isNewRegister: 1,
        isNewPay: 1,
        isNeedShare: 2,
        isRepeat: 0,
        perdayLimit: 1
      };
      return formdata;
    },
    initTicketSingle: function initTicketSingle() {
      return {
        ticketRuleNo: '',
        num: 1
      };
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.discountLevel = this.discountLevel;
      this.searchInfo.activityType = this.activityType;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.searchInfo.discountLevel = this.discountLevel;
      this.searchInfo.activityType = this.activityType;
      this.onSubmit();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 下一步
    addNext: function addNext() {
      debugger;

      if (this.stepActive < 2) {
        this.stepActive++;
      }
    },
    // 上一步
    addBefore: function addBefore() {
      if (this.stepActive > 1) {
        this.stepActive--;
      }
    },
    // 添加券
    onAddTicket: function onAddTicket(index) {
      var that = this;
      that.formData.scancodeTicketList.splice(index + 1, 0, that.initTicketSingle());
    },
    // 删除券
    onDeleteTicket: function onDeleteTicket(index) {
      debugger;
      var that = this;

      if (that.formData.scancodeTicketList.length == 1) {
        return;
      }

      that.formData.scancodeTicketList.splice(index, 1);
    },
    // 获取券详情
    getTicketDetail: function getTicketDetail(item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(item.ticketRuleNo.trim() != '')) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return getTicketRuleDetail({
                  'ticketRuleNo': parseFloat(item.ticketRuleNo)
                });

              case 3:
                res = _context4.sent;

                if (res.code == 0) {
                  item.ticketRuleNo = res.data.ticketRuleNo + '';
                } else {
                  item.ticketRuleNo = '';
                }

              case 5:
                _this4.$forceUpdate();

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 新增
    onAdd: function onAdd() {
      this.type = 'add';
      this.addDialogVisible = true;
      this.dialogTitle = '新增扫码送券活动';
    },
    // 查看
    onRowdbclick: function onRowdbclick(row) {
      var that = this;
      that.onView(row);
    },
    onView: function onView(row) {
      var that = this;
      this.type = 'view';
      this.dialogTitle = '查看扫码送券活动';
      this.viewDialogVisible = true;
      this.handleViewOrUpdate(row);
    },
    // 查看二维码
    onViewQrcode: function onViewQrcode(row) {
      this.qrcodeDialogVisible = true;
      this.dialogTitle = row.activityName;
      this.handleViewOrUpdate(row);
    },
    // 修改
    onUpdate: function onUpdate(row) {
      var that = this;
      that.type = 'update';
      that.addDialogVisible = true;
      that.dialogTitle = '变更扫码送券活动';
      that.handleViewOrUpdate(row);
      that.$forceUpdate();
    },
    handleViewOrUpdate: function handleViewOrUpdate(row) {
      var that = this;
      getActivityDetail({
        'activityNo': row.activityNo
      }).then(function (res) {
        that.qrcodeText = res.data.activitySubScancode.qrcode;
        var shareInfo = JSON.parse(res.data.activityMain.activityMainInfo.shareInfo);
        that.formData.activityNo = res.data.activityMain.activityNo;
        that.formData.activityScancodeNo = res.data.activitySubScancode.activityScancodeNo;
        that.formData.activityName = res.data.activityMain.activityName;
        that.formData.activityStatus = res.data.activityMain.activityStatus;
        that.formData.dateStart = that.$options.filters.formatDate(res.data.activityMain.dateStart);
        that.formData.dateEnd = that.$options.filters.formatDate(res.data.activityMain.dateEnd);
        that.formData.shareTitle = shareInfo.shareTitle;
        that.formData.shareAppLogo = shareInfo.shareAppLogo;
        that.formData.shareTimeLineLogo = shareInfo.shareTimeLineLogo;
        that.formData.auditStatus = res.data.activityMain.auditStatus;
        that.formData.auditRemark = res.data.activityMain.auditRemark;
        that.formData.isNeedShare = res.data.activityMain.activityMainRule.isNeedShare;
        that.formData.isRepeat = res.data.activityMain.activityMainRule.isRepeat;
        that.formData.perdayLimit = res.data.activityMain.activityMainRule.perdayLimit;
        that.formData.isNewRegister = res.data.activityMain.activityMainRule.isNewRegister;
        that.formData.isNewPay = res.data.activityMain.activityMainRule.isNewPay;
        that.formData.scancodeTicketList = JSON.parse(res.data.activitySubScancode.scancodeTicket);
        that.formData.isShowDialog = res.data.activityMain.activityMainRule.isShowDialog; // 不能用以下写法，回显会不展示
        // that.dateRangeValueArr[0] = that.$options.filters.formatDate(row.dateStart)
        // that.dateRangeValueArr[1] = that.$options.filters.formatDate(row.dateEnd)

        that.dateRangeValueArr = [that.formData.dateStart, that.formData.dateEnd];
      }, function (error) {});
    },
    // 审核
    onAudit: function onAudit(row) {
      this.type = 'audit';
      this.auditDialogVisible = true;
      this.dialogTitle = '审核操作';
      this.formData.activityNo = row.activityNo;
    },
    handleAudit: function handleAudit() {
      var that = this;
      auditActivity({
        'activityNo': this.formData.activityNo,
        'auditStatus': this.formData.auditStatus,
        'auditRemark': this.formData.auditRemark
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 启用
    onAble: function onAble(row) {
      var that = this;
      debugger;
      updateActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 1
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 禁用
    onDisable: function onDisable(row) {
      var that = this;
      updateActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 2
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteActivity({
          'activityNo': row.activityNo
        }).then(function (res) {
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.enterDialogRepose(res);
          }
        }, function (error) {});
      }).catch(function (err) {});
    },
    // 上传分享好友图标
    checkShareAppFile: function checkShareAppFile(file) {
      var _this5 = this;

      debugger;
      this.fullscreenLoading = true;
      var isJPG = file.type === 'image/jpeg';
      var isPng = file.type === 'image/png';
      var isLt2M = file.size / 1024 < 500;

      if (!isJPG && !isPng) {
        this.$message.error('上传图片只能是 JPG或png 格式!');
        this.fullscreenLoading = false;
      }

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500k!');
        this.fullscreenLoading = false;
      }

      var isSize = new Promise(function (resolve, reject) {
        var width = 500;
        var height = 400;

        var _URL = window.URL || window.webkitURL;

        var img = new Image();

        img.onload = function () {
          var valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };

        img.src = _URL.createObjectURL(file);
      }).then(function () {
        return file;
      }, function () {
        _this5.$message.error('图片像素必须为500*400!');

        return Promise.reject();
      });
      return (isPng || isJPG) && isLt2M && isSize;
    },
    // 上传分享好友图标
    uploadShareAppSuccess: function uploadShareAppSuccess(res) {
      this.fullscreenLoading = false;

      if (res.code != 0) {
        this.$message({
          type: 'warning',
          message: res.msg
        });
        return;
      }

      debugger;

      if (res.data.file.url && res.data.file.url.slice(0, 4) !== 'http') {
        this.formData.shareAppLogo = this.path + '/' + res.data.file.url;
      } else {
        this.formData.shareAppLogo = res.data.file.url;
      }
    },
    // 上传分享朋友圈图标
    checkShareTimeLineFile: function checkShareTimeLineFile(file) {
      var _this6 = this;

      debugger;
      this.fullscreenLoading = true;
      var isJPG = file.type === 'image/jpeg';
      var isPng = file.type === 'image/png';
      var isLt2M = file.size / 1024 < 500;

      if (!isJPG && !isPng) {
        this.$message.error('上传图片只能是 JPG或png 格式!');
        this.fullscreenLoading = false;
      }

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500k!');
        this.fullscreenLoading = false;
      }

      var isSize = new Promise(function (resolve, reject) {
        var width = 200;
        var height = 200;

        var _URL = window.URL || window.webkitURL;

        var img = new Image();

        img.onload = function () {
          var valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };

        img.src = _URL.createObjectURL(file);
      }).then(function () {
        return file;
      }, function () {
        _this6.$message.error('图片像素必须为200*200!');

        return Promise.reject();
      });
      return (isPng || isJPG) && isLt2M && isSize;
    },
    // 上传分享朋友圈图标
    uploadShareTimeLineSuccess: function uploadShareTimeLineSuccess(res) {
      this.fullscreenLoading = false;

      if (res.code != 0) {
        this.$message({
          type: 'warning',
          message: res.msg
        });
        return;
      }

      if (res.data.file.url && res.data.file.url.slice(0, 4) !== 'http') {
        this.formData.shareTimeLineLogo = this.path + '/' + res.data.file.url;
      } else {
        this.formData.shareTimeLineLogo = res.data.file.url;
      }
    },
    // 图片上传失败
    uploadError: function uploadError() {
      this.$message({
        type: 'error',
        message: '上传失败'
      });
      this.fullscreenLoading = false;
    },
    closeDialog: function closeDialog() {
      this.addDialogVisible = false;
      this.viewDialogVisible = false;
      this.auditDialogVisible = false;
      this.qrcodeDialogVisible = false;
      this.qrcodeText = '';
      this.type = '';
      this.dialogTitle = '';
      this.dateRangeValueArr = [];
      this.stepActive = 1;
      this.formData = this.initData();
    },
    onDialogSubmit: function onDialogSubmit() {
      var that = this;
      debugger;

      switch (that.type) {
        case 'add':
          that.handleAdd();
          break;

        case 'update':
          that.handleUpdate();
          break;

        case 'audit':
          that.handleAudit();
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 新增保存
    handleAdd: function handleAdd() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this7;

                if (that.validFormData()) {
                  createActivity(that.getParam()).then(function (res) {
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.enterDialogRepose(res);
                    }
                  }, function (error) {});
                }

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 变更保存
    handleUpdate: function handleUpdate(refFormData) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, param;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this8;

                if (that.validFormData()) {
                  param = that.getParam();
                  param.auditStatus = 1;
                  param.activityStatus = 2;
                  updateActivity(param).then(function (res) {
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.enterDialogRepose(res);
                    }
                  }, function (error) {});
                }

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 公共校验函数
    validFormData: function validFormData() {
      var that = this;
      var valid = true;

      if (!that.formData.activityName || that.dateRangeValueArr.length == 0 || that.formData.scancodeTicketList.length == 0) {
        that.$message({
          type: 'warning',
          message: '请完善活动规则信息'
        });
        return false;
      }

      that.formData.scancodeTicketList.forEach(function (item) {
        if (!item.ticketRuleNo || !item.ticketRuleNo.trim() || item.num == '' || item.num < 1) {
          valid = false;
        }
      });

      if (!valid) {
        that.$message({
          type: 'warning',
          message: '请完善赠送优惠券信息'
        });
        return false;
      }

      if (that.formData.isNeedShare == 1 && (!that.formData.shareTitle || !that.formData.shareAppLogo || !that.formData.shareTimeLineLogo)) {
        that.$message({
          type: 'warning',
          message: '请完善分享信息'
        });
        return false;
      }

      return true;
    },
    getParam: function getParam() {
      debugger;
      var that = this;
      var formData = JSON.parse(JSON.stringify(that.formData));
      var param = {
        activityNo: formData.activityNo,
        activityName: formData.activityName,
        activitySellerType: this.discountLevel,
        activityType: this.activityType,
        activityStatus: formData.activityStatus,
        dateStart: this.dateRangeValueArr[0],
        dateEnd: this.dateRangeValueArr[1],
        activityMainInfo: {
          shareInfo: {}
        },
        activityMainRule: {
          isNewRegister: this.formData.isNewRegister,
          isNewPay: this.formData.isNewPay,
          isNeedShare: this.formData.isNeedShare,
          isRepeat: this.formData.isRepeat,
          perdayLimit: this.formData.perdayLimit,
          isShowDialog: formData.isShowDialog,
          isLimitGoods: 2,
          isLimitSeller: 2
        },
        activitySubScancode: {
          activityScancodeNo: this.formData.activityScancodeNo,
          scancodeTicket: JSON.stringify(this.formData.scancodeTicketList)
        }
      };
      param.activityMainInfo.shareInfo = JSON.stringify({
        'shareTitle': formData.shareTitle,
        'shareAppLogo': formData.shareAppLogo,
        'shareTimeLineLogo': formData.shareTimeLineLogo
      });
      return param;
    }
  }
};